/**
 * Triggers a browser download from a data URL (e.g. canvas toDataURL output).
 * Does not make any network request.
 */
function downloadDataURL(dataURL: string, filename: string): void {
  const a = document.createElement('a');
  a.href = dataURL;
  a.download = filename;
  a.click();
}

export default downloadDataURL;
